function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M7.99 17.85L2.34 12.2C1.55 11.41 2.11 10.05 3.23 10.05H7.99V17.85Z",
  fill: "url(#paint0_radial_28327_4754)"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M7.99 17.85L2.34 12.2C1.55 11.41 2.11 10.05 3.23 10.05H7.99V17.85Z",
  fill: "url(#paint1_linear_28327_4754)"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M24.02 17.85L29.67 12.2C30.46 11.41 29.9 10.05 28.78 10.05H24.02V17.85V17.85Z",
  fill: "url(#paint2_linear_28327_4754)"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M24.02 17.85L29.67 12.2C30.46 11.41 29.9 10.05 28.78 10.05H24.02V17.85V17.85Z",
  fill: "url(#paint3_radial_28327_4754)"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M24.02 17.85L29.67 12.2C30.46 11.41 29.9 10.05 28.78 10.05H24.02V17.85V17.85Z",
  fill: "url(#paint4_radial_28327_4754)"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M24.02 17.85L29.67 12.2C30.46 11.41 29.9 10.05 28.78 10.05H24.02V17.85V17.85Z",
  fill: "url(#paint5_linear_28327_4754)"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M16 2C11.56 2 7.96997 5.59 7.96997 10.03V19.29H24.03V10.03C24.02 5.59 20.43 2 16 2Z",
  fill: "url(#paint6_linear_28327_4754)"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M16 2C11.56 2 7.96997 5.59 7.96997 10.03V19.29H24.03V10.03C24.02 5.59 20.43 2 16 2Z",
  fill: "url(#paint7_radial_28327_4754)"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M16 2C11.56 2 7.96997 5.59 7.96997 10.03V19.29H24.03V10.03C24.02 5.59 20.43 2 16 2Z",
  fill: "url(#paint8_linear_28327_4754)"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M16 2C11.56 2 7.96997 5.59 7.96997 10.03V19.29H24.03V10.03C24.02 5.59 20.43 2 16 2Z",
  fill: "url(#paint9_radial_28327_4754)"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M16 2C11.56 2 7.96997 5.59 7.96997 10.03V19.29H24.03V10.03C24.02 5.59 20.43 2 16 2Z",
  fill: "url(#paint10_radial_28327_4754)"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M16 2C11.56 2 7.96997 5.59 7.96997 10.03V19.29H24.03V10.03C24.02 5.59 20.43 2 16 2Z",
  fill: "url(#paint11_radial_28327_4754)"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M16 2C11.56 2 7.96997 5.59 7.96997 10.03V19.29H24.03V10.03C24.02 5.59 20.43 2 16 2Z",
  fill: "url(#paint12_radial_28327_4754)"
});

var _ref15 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter0_f_28327_4754)"
}, /*#__PURE__*/React.createElement("ellipse", {
  cx: 17.8057,
  cy: 7.07328,
  rx: 5.80573,
  ry: 3.56796,
  transform: "rotate(28.8176 17.8057 7.07328)",
  fill: "url(#paint13_linear_28327_4754)"
}));

var _ref16 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter1_i_28327_4754)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M25.4268 14.3183C25.3292 14.22 25.1704 14.2197 25.0724 14.3176L21.9668 17.4233C21.8691 17.5209 21.7108 17.5209 21.6132 17.4233L16.1668 11.9768C16.0691 11.8792 15.9108 11.8792 15.8132 11.9768L10.3668 17.4233C10.2691 17.5209 10.1108 17.5209 10.0132 17.4233L6.91676 14.3268C6.81913 14.2292 6.66083 14.2292 6.5632 14.3268L3.37643 17.5136C3.28266 17.6074 3.22952 17.7354 3.23164 17.868C3.34259 24.822 9.00942 30.42 15.99 30.42C22.9608 30.42 28.6277 24.8217 28.748 17.8771C28.7503 17.745 28.6978 17.6174 28.6047 17.5236L25.4268 14.3183Z",
  fill: "url(#paint14_linear_28327_4754)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M25.4268 14.3183C25.3292 14.22 25.1704 14.2197 25.0724 14.3176L21.9668 17.4233C21.8691 17.5209 21.7108 17.5209 21.6132 17.4233L16.1668 11.9768C16.0691 11.8792 15.9108 11.8792 15.8132 11.9768L10.3668 17.4233C10.2691 17.5209 10.1108 17.5209 10.0132 17.4233L6.91676 14.3268C6.81913 14.2292 6.66083 14.2292 6.5632 14.3268L3.37643 17.5136C3.28266 17.6074 3.22952 17.7354 3.23164 17.868C3.34259 24.822 9.00942 30.42 15.99 30.42C22.9608 30.42 28.6277 24.8217 28.748 17.8771C28.7503 17.745 28.6978 17.6174 28.6047 17.5236L25.4268 14.3183Z",
  fill: "url(#paint15_radial_28327_4754)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M25.4268 14.3183C25.3292 14.22 25.1704 14.2197 25.0724 14.3176L21.9668 17.4233C21.8691 17.5209 21.7108 17.5209 21.6132 17.4233L16.1668 11.9768C16.0691 11.8792 15.9108 11.8792 15.8132 11.9768L10.3668 17.4233C10.2691 17.5209 10.1108 17.5209 10.0132 17.4233L6.91676 14.3268C6.81913 14.2292 6.66083 14.2292 6.5632 14.3268L3.37643 17.5136C3.28266 17.6074 3.22952 17.7354 3.23164 17.868C3.34259 24.822 9.00942 30.42 15.99 30.42C22.9608 30.42 28.6277 24.8217 28.748 17.8771C28.7503 17.745 28.6978 17.6174 28.6047 17.5236L25.4268 14.3183Z",
  fill: "url(#paint16_radial_28327_4754)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M25.4268 14.3183C25.3292 14.22 25.1704 14.2197 25.0724 14.3176L21.9668 17.4233C21.8691 17.5209 21.7108 17.5209 21.6132 17.4233L16.1668 11.9768C16.0691 11.8792 15.9108 11.8792 15.8132 11.9768L10.3668 17.4233C10.2691 17.5209 10.1108 17.5209 10.0132 17.4233L6.91676 14.3268C6.81913 14.2292 6.66083 14.2292 6.5632 14.3268L3.37643 17.5136C3.28266 17.6074 3.22952 17.7354 3.23164 17.868C3.34259 24.822 9.00942 30.42 15.99 30.42C22.9608 30.42 28.6277 24.8217 28.748 17.8771C28.7503 17.745 28.6978 17.6174 28.6047 17.5236L25.4268 14.3183Z",
  fill: "url(#paint17_radial_28327_4754)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M25.4268 14.3183C25.3292 14.22 25.1704 14.2197 25.0724 14.3176L21.9668 17.4233C21.8691 17.5209 21.7108 17.5209 21.6132 17.4233L16.1668 11.9768C16.0691 11.8792 15.9108 11.8792 15.8132 11.9768L10.3668 17.4233C10.2691 17.5209 10.1108 17.5209 10.0132 17.4233L6.91676 14.3268C6.81913 14.2292 6.66083 14.2292 6.5632 14.3268L3.37643 17.5136C3.28266 17.6074 3.22952 17.7354 3.23164 17.868C3.34259 24.822 9.00942 30.42 15.99 30.42C22.9608 30.42 28.6277 24.8217 28.748 17.8771C28.7503 17.745 28.6978 17.6174 28.6047 17.5236L25.4268 14.3183Z",
  fill: "url(#paint18_radial_28327_4754)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M25.4268 14.3183C25.3292 14.22 25.1704 14.2197 25.0724 14.3176L21.9668 17.4233C21.8691 17.5209 21.7108 17.5209 21.6132 17.4233L16.1668 11.9768C16.0691 11.8792 15.9108 11.8792 15.8132 11.9768L10.3668 17.4233C10.2691 17.5209 10.1108 17.5209 10.0132 17.4233L6.91676 14.3268C6.81913 14.2292 6.66083 14.2292 6.5632 14.3268L3.37643 17.5136C3.28266 17.6074 3.22952 17.7354 3.23164 17.868C3.34259 24.822 9.00942 30.42 15.99 30.42C22.9608 30.42 28.6277 24.8217 28.748 17.8771C28.7503 17.745 28.6978 17.6174 28.6047 17.5236L25.4268 14.3183Z",
  fill: "url(#paint19_radial_28327_4754)"
}));

var _ref17 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter2_f_28327_4754)"
}, /*#__PURE__*/React.createElement("ellipse", {
  cx: 15.1981,
  cy: 9.68767,
  rx: 2.63454,
  ry: 0.970068,
  transform: "rotate(-16.6311 15.1981 9.68767)",
  fill: "url(#paint20_linear_28327_4754)"
}));

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M11.4469 8.00415C11.723 8.00415 11.9469 7.78029 11.9469 7.50415C11.9469 7.22801 11.723 7.00415 11.4469 7.00415C11.1708 7.00415 10.9469 7.22801 10.9469 7.50415C10.9469 7.78029 11.1708 8.00415 11.4469 8.00415Z",
  fill: "url(#paint21_radial_28327_4754)"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M11.4469 8.00415C11.723 8.00415 11.9469 7.78029 11.9469 7.50415C11.9469 7.22801 11.723 7.00415 11.4469 7.00415C11.1708 7.00415 10.9469 7.22801 10.9469 7.50415C10.9469 7.78029 11.1708 8.00415 11.4469 8.00415Z",
  fill: "url(#paint22_radial_28327_4754)"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  d: "M11.4469 8.00415C11.723 8.00415 11.9469 7.78029 11.9469 7.50415C11.9469 7.22801 11.723 7.00415 11.4469 7.00415C11.1708 7.00415 10.9469 7.22801 10.9469 7.50415C10.9469 7.78029 11.1708 8.00415 11.4469 8.00415Z",
  fill: "url(#paint23_linear_28327_4754)"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "M20.5431 8.00415C20.8192 8.00415 21.0431 7.78029 21.0431 7.50415C21.0431 7.22801 20.8192 7.00415 20.5431 7.00415C20.2669 7.00415 20.0431 7.22801 20.0431 7.50415C20.0431 7.78029 20.2669 8.00415 20.5431 8.00415Z",
  fill: "url(#paint24_radial_28327_4754)"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  d: "M20.5431 8.00415C20.8192 8.00415 21.0431 7.78029 21.0431 7.50415C21.0431 7.22801 20.8192 7.00415 20.5431 7.00415C20.2669 7.00415 20.0431 7.22801 20.0431 7.50415C20.0431 7.78029 20.2669 8.00415 20.5431 8.00415Z",
  fill: "url(#paint25_radial_28327_4754)"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  d: "M20.5431 8.00415C20.8192 8.00415 21.0431 7.78029 21.0431 7.50415C21.0431 7.22801 20.8192 7.00415 20.5431 7.00415C20.2669 7.00415 20.0431 7.22801 20.0431 7.50415C20.0431 7.78029 20.2669 8.00415 20.5431 8.00415Z",
  fill: "url(#paint26_linear_28327_4754)"
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  d: "M17.92 9.08992H14.07C14.07 8.02992 14.93 7.16992 15.99 7.16992C17.05 7.16992 17.92 8.02992 17.92 9.08992Z",
  fill: "#ED6C32"
});

var _ref25 = /*#__PURE__*/React.createElement("path", {
  d: "M17.92 9.08992H14.07C14.07 8.02992 14.93 7.16992 15.99 7.16992C17.05 7.16992 17.92 8.02992 17.92 9.08992Z",
  fill: "url(#paint27_radial_28327_4754)"
});

var _ref26 = /*#__PURE__*/React.createElement("path", {
  d: "M17.92 9.08992H14.07C14.07 8.02992 14.93 7.16992 15.99 7.16992C17.05 7.16992 17.92 8.02992 17.92 9.08992Z",
  fill: "url(#paint28_linear_28327_4754)"
});

var _ref27 = /*#__PURE__*/React.createElement("path", {
  d: "M17.92 9.08992H14.07C14.07 8.02992 14.93 7.16992 15.99 7.16992C17.05 7.16992 17.92 8.02992 17.92 9.08992Z",
  fill: "url(#paint29_radial_28327_4754)"
});

var _ref28 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter3_f_28327_4754)"
}, /*#__PURE__*/React.createElement("ellipse", {
  cx: 9.27852,
  cy: 22.4745,
  rx: 3.67943,
  ry: 6.23559,
  transform: "rotate(-34.2295 9.27852 22.4745)",
  fill: "url(#paint30_radial_28327_4754)"
}));

var _ref29 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter0_f_28327_4754",
  x: 10.9347,
  y: 1.37744,
  width: 13.7421,
  height: 11.3916,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.75,
  result: "effect1_foregroundBlur_28327_4754"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter1_i_28327_4754",
  x: 3.23157,
  y: 11.9036,
  width: 25.6165,
  height: 18.6166,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: 0.1,
  dy: 0.1
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.1
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.682353 0 0 0 0 0.615686 0 0 0 0 0.6 0 0 0 0.5 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "shape",
  result: "effect1_innerShadow_28327_4754"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter2_f_28327_4754",
  x: 11.6584,
  y: 7.49072,
  width: 7.07953,
  height: 4.3938,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.5,
  result: "effect1_foregroundBlur_28327_4754"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter3_f_28327_4754",
  x: 3.63544,
  y: 15.9175,
  width: 11.2862,
  height: 13.114,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.5,
  result: "effect1_foregroundBlur_28327_4754"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint0_radial_28327_4754",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(1.51788 10.05) rotate(26.1542) scale(11.2542 6.35842)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#DAB830"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#B96D1E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#DB8021"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear_28327_4754",
  x1: 8.81415,
  y1: 15.9063,
  x2: 6.64057,
  y2: 16.1511,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#CD7C10"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#CD7C10",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint2_linear_28327_4754",
  x1: 30.5818,
  y1: 8.554,
  x2: 24.02,
  y2: 16.1111,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F8EC1D"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F5891F"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint3_radial_28327_4754",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(36.1361 8.0136) rotate(156.138) scale(12.5688 1.52199)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F8EC1D"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F8EC1D",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint4_radial_28327_4754",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(30.0396 10.5879) rotate(154.22) scale(1.91466 1.09139)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F8EC1D"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.512609,
  stopColor: "#F8EC1D",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint5_linear_28327_4754",
  x1: 27.2876,
  y1: 15.461,
  x2: 26.4826,
  y2: 13.4891,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#D39344"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#DF9D4C",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint6_linear_28327_4754",
  x1: 15.9965,
  y1: 0.0312999,
  x2: 15.9965,
  y2: 22.2446,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F8EC1D"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F5891F"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint7_radial_28327_4754",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(24.3888 20.7261) rotate(-137.406) scale(25.7358 20.3264)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.664028,
  stopColor: "#BBA553",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#BBA553"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint8_linear_28327_4754",
  x1: 9.48917,
  y1: 13.5222,
  x2: 7.09244,
  y2: 13.5222,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#BBA553",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#BBA553"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint9_radial_28327_4754",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(9.84537 17.25) rotate(-38.3371) scale(13.5555 13.4432)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#BD7614"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#D18B2B",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint10_radial_28327_4754",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(21.6579 18.75) rotate(-90) scale(3.875 2.48438)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.205645,
  stopColor: "#D6722E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#D6722E",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint11_radial_28327_4754",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(10.1579 18.875) rotate(-90) scale(4.1875 2.68473)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.205645,
  stopColor: "#D6722E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#D6722E",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint12_radial_28327_4754",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(13.0329 18) rotate(-130.956) scale(4.38615 5.89747)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.30599,
  stopColor: "#D6722E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#D6722E",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint13_linear_28327_4754",
  x1: 18.0277,
  y1: 1.6244,
  x2: 17.8057,
  y2: 10.6412,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F8E31D"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F8E31D",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint14_linear_28327_4754",
  x1: 15.9965,
  y1: 12.8125,
  x2: 15.9965,
  y2: 32.8125,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#DED6E7"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#C0AADD"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint15_radial_28327_4754",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(16.5329 17) rotate(137.555) scale(16.8547 16.6376)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.719299,
  stopColor: "#AEA7BB",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#87838E"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint16_radial_28327_4754",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(3.43912 16.125) rotate(48.3665) scale(2.2578 15.0904)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#87838E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.686446,
  stopColor: "#AEA7BB",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint17_radial_28327_4754",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(23.1579 15.6563) rotate(83.8482) scale(10.498 8.96849)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#EBE3F2"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#EBE3F2",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint18_radial_28327_4754",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(13.9704 16.5625) rotate(20.3231) scale(17.9952 21.2822)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.689867,
  stopColor: "#AEA7BB",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.948509,
  stopColor: "#87838E"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint19_radial_28327_4754",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(25.3454 36) rotate(-125.828) scale(18.365 17.1085)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#A58BC3"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.931437,
  stopColor: "#A58BC3",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint20_linear_28327_4754",
  x1: 17.3649,
  y1: 9.79902,
  x2: 10.5797,
  y2: 10.8613,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#E5951B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#E5951B",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint21_radial_28327_4754",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(11.5953 7.34326) rotate(125.838) scale(0.693863 0.618606)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.00558659,
  stopColor: "#433437"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#3B2838"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint22_radial_28327_4754",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(11.6338 7.37915) rotate(137.643) scale(0.35946 0.316238)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#5C5051"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#5C5051",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint23_linear_28327_4754",
  x1: 11.3486,
  y1: 7.11143,
  x2: 11.0049,
  y2: 6.89268,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#5C5051",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#5C5051"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint24_radial_28327_4754",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(20.6915 7.34326) rotate(125.838) scale(0.693863 0.618606)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.00558659,
  stopColor: "#433437"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#3B2838"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint25_radial_28327_4754",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(20.7299 7.37915) rotate(137.643) scale(0.35946 0.316237)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#5C5051"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#5C5051",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint26_linear_28327_4754",
  x1: 20.4448,
  y1: 7.11143,
  x2: 20.101,
  y2: 6.89268,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#5C5051",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#5C5051"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint27_radial_28327_4754",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(16.861 8.93742) rotate(-90) scale(1.15625 1.6875)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FF8E64"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FF8E64",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint28_linear_28327_4754",
  x1: 15.995,
  y1: 9.1718,
  x2: 15.995,
  y2: 8.74992,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C1411B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.787037,
  stopColor: "#EA6038",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint29_radial_28327_4754",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(14.5798 9.59367) rotate(-80.3077) scale(1.48495 0.314928)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.166103,
  stopColor: "#FF8E64"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FF8E64",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint30_radial_28327_4754",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(6.07832 20.2972) rotate(-1.49693) scale(9.16158 20.8424)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#E7DDF9"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.619715,
  stopColor: "#E7DDF9",
  stopOpacity: 0
})));

function SvgHatchingChick(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHatchingChick);
export default __webpack_public_path__ + "static/media/hatching-chick.c52a2417.svg";
export { ForwardRef as ReactComponent };